import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { RoutingService } from '../../services/routing.service';
import { RestapiService } from '../../services/restapi.service';
import { SeoService } from 'src/app/services/seo.service';
@Component({
  selector: 'app-articulo',
  templateUrl: './articulo.component.html',
  styleUrls: ['./articulo.component.scss']
})
export class ArticuloComponent implements OnInit {

  url: string;
  cont: any;
  private routeObs: Subscription;
  constructor(
    private activatedRoute: ActivatedRoute,
    public route: RoutingService,
    public seo: SeoService,
    public api: RestapiService
  ) {
    this.routeObs = this.route.onRouteChange.subscribe(res => {
      console.log('routeObs change')
      setTimeout(() => {
        this.route.setCurrent(window.location.pathname);
        this.loadContent();
      }, 10);
    });
  }

  ngOnInit(): void {
    this.loadContent()
  }

  loadContent() {
    this.url = this.activatedRoute.snapshot.paramMap.get('url');
    this.api.getdata('websection', {
      filters: { name: { value: this.url } }
    }).subscribe(res => {
      if (res.status == true) {
        console.log('CURRENT WEBSECTION', res);
        this.cont = res.result.data[0];
        this.seo.generateTags({
          title: 'WWF Educación Ambiental, ' + this.cont.tagtitle,
          description: this.cont.tagdescription,
          image: this.api.route + this.cont.tagimage,
          slug: window.location.href,
        });
      }
      else {
        console.log('ERROR ON LOAD', this.url);
      }
    })
  }



}
